/**
 * Returns the Redux `Store`.
 *
 * API: http://rackt.org/redux/docs/api/Store.html
 */
import * as Redux from 'redux';
import { CLEAR_USER } from 'actions';
import thunk from 'redux-thunk';

import logger from './middleware/logger';
import * as reducers from 'reducers';
import * as persistState from 'redux-localstorage';

// http://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
const appReducer = Redux.combineReducers(reducers);

const reducer = (state: RootState | undefined, action: Redux.Action) => {
  if (action.type === CLEAR_USER) {
    state = undefined; // eslint-disable-line no-param-reassign
  }
  return appReducer(state as any, action);
};

function configurePersistState() {
  return persistState(
    [
      'app',
      'constants',
      'tradeConstants',
      'users',
      'polls',
      'dataSubscription',
      'ocMessage',
      'i18n',
    ],
    { key: 'sourcesage' }
  );
}

let configureStore: () => Redux.Store<RootState>;

if (__DEV__) {
  configureStore = () => {
    const store = Redux.createStore(
      reducer as Redux.Reducer<RootState>,
      Redux.compose(
        Redux.applyMiddleware(thunk, logger),
        configurePersistState()
      )
    );

    /**
     * Hot replacement of Reducer. Necessary for webpack hot replacement during dev mode.
     */
    if (module.hot) {
      module.hot.accept('../reducers', () => {
        const nextReducer = require('../reducers/index');
        store.replaceReducer(nextReducer);
      });
    }

    return store as Redux.Store<RootState>;
  };
} else if (__TESTING__) {
  configureStore = () => {
    return Redux.createStore(
      reducer as Redux.Reducer<RootState>,
      Redux.compose(Redux.applyMiddleware(thunk))
    );
  };
} else {
  configureStore = () => {
    return Redux.createStore(
      reducer as Redux.Reducer<RootState>,
      Redux.compose(
        Redux.applyMiddleware(thunk),
        configurePersistState()
      )
    ) as Redux.Store<RootState>;
  };
}

export default configureStore;



// WEBPACK FOOTER //
// ./app/store/configureStore.ts